// 问卷新版接口 http://project.srv.ourwill.cn/zentaopms/www/index.php?m=task&f=view&taskID=1129
import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.surveyApipath + '/answer-report/');

export const answerReport = {
	//答案列表-条件查询
	getQueryAnswer(surveyId, data, params) {
		return http.post(`list/${surveyId}`, data, { params });
	},
	//获取全部答案source
	getSourceList(surveyId) {
		return http.get(`${surveyId}`, { params: { page: 0 } });
	},
	//获取答案明细
	geteditorView(surveyId, id) {
		return http.get('getSurveyAnswer', { params: { surveyId, source: id } });
	},
	//批量删除
	batchDeleting(surveyId, data) {
		return http.delete(`/${surveyId}`, { data });
	},
	//获取问卷统计信息
	getProjectStatistics(surveyId) {
		return http.get(`/statistics/${surveyId}`);
	},
	//execl导出
	getExcelForm(surveyId) {
		return http.get('/export', { params: { surveyId } });
	},
};
